import React, { lazy } from 'react';

const Billing = lazy(() => import('./Billing'));

const BillingAppConfig = {
	settings: {
		layout: {}
	},
	auth: ['system.billing.view'],
	routes: [
		{
			path: '/apps/billing',
			element: <Billing />
		}
	]
};

export default BillingAppConfig;
